/*=========================================================================================
  File Name: moduleMapState.js
  Description: Todo Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	toggleMapSidebar: false,
	popupStreeViewActive: false,
	mapStyle: "blue_essence",
	activeTrafficLayer: false,
	optionsProgramedRoute: {
		strokeColor: "#ff8c34",
		strokeOpacity: 0.5,
		lineWidth: 8,
		optimizeWaypoints: true,
		id: "RP",
	},
	optionsExecutedRoute: {
		strokeColor: "#0B8FF4",
		strokeOpacity: 0.8,
		lineWidth: 8,
		optimizeWaypoints: false,
		id: "RE",
		showWaypoints: false,
		waypointsLabel: false,
		waypointsColor: "#ff0000",
		lineWaypoints: false,
		lineWaypointsStrokeColor: "#ff0000",
		lineWaypointsStrokeOpacity: 0.8,
		lineWaypointsStrokeWeight: 3,
	},
	optionsExecutedSkyway: {
		strokeColor: "#32BA7C",
		strokeOpacity: 0.8,
		strokeWeight: 8,
		show: true,
		id: "RES",
	},
	toggleGeorreferencer: false,
	toggleRoutesLegends: false,
	resourceRoutesLegends: [],
	executedRoutes: [],
	routeType: "PROGRAMED",
	colorMap: new Map(),
	module: null,
	zoneList: [],
	locatePanicAlarm: {
		trigger: 0,
		notification: {},
	},
};
